import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";
import Hero from "./components/Hero";
import { Box, Divider } from "@mui/material";
import Sidebar from "./components/Sidebar";
import Work from "./components/Work";
import Contact from "./components/Contact";

function App() {
  return (
    <>
      <Box className="sidebar">
        <Sidebar />
      </Box>
      <Box
        className="main-content"
        sx={{ marginLeft: "250px", paddingTop: "40px" }}
        id="top"
      >
        <ThemeProvider theme={theme}>
          <Hero />
          <Work />
          <Divider sx={{ borderColor: "rgb(41, 41, 41)", marginTop: "24px" }} />
          <Contact />
        </ThemeProvider>
      </Box>
    </>
  );
}

export default App;
